import {
	getInquiriesByDateRange,
	getInquiries,
	patchInquiry,
	Inquiry,
	addInquiryMessage,
	getInquiryById
} from "../api/inquiries";
import { store } from "../store";
import { setSnackbarMessage } from "../actions/store/snackbar-actions";
import {
	updateInquiries as updateInquiriesInStore,
	updateSingleInquiry as updateSingleInquiryInStore,
	removeInquiry as removeInquiryInStore
} from "./store/app-actions";
import { addReservation } from "./reservation-actions";

export const getInquiriesAndUpdateStore = async (start: Date, end: Date) => {
	try {
		let inquiries;

		if (start && end) {
			inquiries = await getInquiriesByDateRange(start, end);
		} else {
			inquiries = await getInquiries();
		}

		store.dispatch(updateInquiriesInStore(inquiries));
	} catch (e) {
		if (e.message !== "Not Found") {
			store.dispatch(
				setSnackbarMessage(
					"Keine Resevierungen für den ausgewählten Zeitraum vorhanden!",
					"warning"
				)
			);
		}
	}
};

export const updateInquiry = async (
	id: string,
	updateData: Partial<Inquiry>
) => {
	try {
		const res = await patchInquiry(id, updateData);

		// If accepted or rejected -> remove from store
		if (res.accepted || res.rejected) {
			store.dispatch(removeInquiryInStore(id));
		} else {
			store.dispatch(updateSingleInquiryInStore(id, res));
		}
	} catch (e) {
		console.error(e);
		store.dispatch(
			setSnackbarMessage(
				"Aktualisierung der Anfrage fehlgeschlagen!",
				"error"
			)
		);
	}
};

export const refreshInquiry = async (id: string) => {
	try {
		const res = await getInquiryById(id);

		store.dispatch(updateSingleInquiryInStore(id, res));
	} catch (e) {
		console.error(e);
		store.dispatch(
			setSnackbarMessage(
				"Aktualisierung der Anfrage fehlgeschlagen!",
				"error"
			)
		);
	}
};

export const addInquiryMessageAndUpdateStore = async (
	inquiryId: string,
	message: string
) => {
	try {
		await addInquiryMessage(inquiryId, message);
		const res = await getInquiryById(inquiryId);

		store.dispatch(updateSingleInquiryInStore(inquiryId, res));

		store.dispatch(
			setSnackbarMessage("Nachricht wurde gesendet!", "success")
		);
	} catch (e) {
		console.error(e);
		store.dispatch(
			setSnackbarMessage("Konnte Nachricht nicht senden!", "error")
		);
	}
};
